import { render, staticRenderFns } from "./ParticlesBackground.vue?vue&type=template&id=27457963&scoped=true"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"
import style0 from "./ParticlesBackground.vue?vue&type=style&index=0&id=27457963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27457963",
  null
  
)

export default component.exports